import { AppBar, Box, Tab, Tabs } from '@mui/material'
import { FC } from 'react'
import { connect } from 'react-redux'
import { RoleType, actions as appActions } from '../../redux/appReducer'
import { StateType } from '../../redux/store'
import { TabPanel } from '../AppTabs'
import CategoriesTab from './Category/CategoriesTab'
import ConfigsTab from './Configs/ConfigsTab'
import MarkupTab from './Markup/MarkupTab'
import DiscountTiersTab from './DiscountTiers/DiscountTiersTab'

interface IProps {
  activeTab: number
  role: RoleType

  setActiveTab(value: number): void
}
const AdminTab: FC<IProps> = (props) => {
  return (
    <Box>
      <AppBar position="static" color="default">
        <Tabs
          value={props.activeTab}
          onChange={(e, newValue) => props.setActiveTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Categories" value={0} />
          <Tab label="Markups" value={1} />
          <Tab label="Configs" value={2} />
          <Tab label="Discount Tiers" value={3} />
        </Tabs>
      </AppBar>

      <TabPanel value={props.activeTab} index={0}>
        <CategoriesTab />
      </TabPanel>
      <TabPanel value={props.activeTab} index={1}>
        <MarkupTab />
      </TabPanel>

      <TabPanel value={props.activeTab} index={2}>
        <ConfigsTab />
      </TabPanel>

      <TabPanel value={props.activeTab} index={3}>
        <DiscountTiersTab />
      </TabPanel>
    </Box>
  )
}

const mapStateToProps = (state: StateType) => ({
  activeTab: state.appReducer.activeAdminTab,
  role: state.appReducer.user?.role || 'none',
})

export default connect(mapStateToProps, {
  setActiveTab: appActions.setAdminActiveTab,
})(AdminTab)
